import { styles } from 'scenes/home/more/index/styles/styles'
import HelperDate, { dateFormat } from 'utils/helper-date'
import Text from "theme/Text";
import React from 'react'
import useMinute from 'utils/hooks/use-minute'

const TimeView = () => {
	
	const minute = useMinute(); // Keep this hook to render every exact minute
	
	return (
		<Text style={ styles.modTime}>{ HelperDate.date().format( dateFormat.DATE_TIME ) }</Text>
	)
}

export default TimeView
